module.exports = __webpack_public_path__ + "static/img/apple.f39ac5f.jpg";